export const formatTooltipTitle = (label) => {
  if (!label || typeof label !== "string") return "";
  const trimmed = label.trim();
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
};
